export default __webpack_public_path__ + "static/media/Цахим_хэрэглээний_зардал.27ce0bf3.pptx";